export default __webpack_public_path__ + "static/media/app-ftz-04.7797d581.png";